import { Order } from "./order";
import { OrderPayDetail } from "./order-pay-detail";
import { Budget } from "./budget";

export class OrderPay {
    id: number;
    order: Order;
    budget?: Budget;
    account: any;
    name: string;
    payType: any;
    brand: any;
    date: string;
    receptDate: string;
    parcel: number;
    value: number;
    orderPayDetail: OrderPayDetail;
    userUpdated?: string;
    userCreated?: string;
    notes?: string;
    transactionIdentifier?: string;
}
